import { getLastSession } from "../axios/routes/user";
import { StorageServiceInstance } from "../services/storage";
import { getSuiteName } from "./suite";

export const loadLastSession = async (email: string) => {
  if (!email) {
    return null;
  }

  try {
    const lastSession = await getLastSession(email);
    const lastSessionDate = lastSession.updated || lastSession.created || "";
    if (lastSessionDate) {
      const diff = new Date().getTime() - new Date(lastSessionDate).getTime();
      const diffInDays = diff / (24 * 60 * 60 * 1000);
      if (diffInDays < 3 && lastSession.game) {
        // we should load the last game data to prepare images
        await StorageServiceInstance.loadGameData(lastSession.game);

        const suite = getSuiteName(lastSession.section);
        if (suite) {
          lastSession.suite = suite;
        }

        return lastSession;
      }
    }
  } catch (err) {
    console.log("error during last session fetch", err);
  }

  return null;
};
